module.exports = __webpack_public_path__ + "img/tablista.815e1c0e.png";